angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/login/signup.html',
    '<update-title title="PEforHire.com"></update-title>\n' +
    '<!-- Logo -->\n' +
    '<header class="logo-bar">\n' +
    '    <div class="container-fluid">\n' +
    '        <a href="" ui-sref="index" class="logo">\n' +
    '            <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                <polygon class="pol-a" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53" />\n' +
    '                <polygon class="pol-b" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7" />\n' +
    '                <polygon class="pol-c" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3" />\n' +
    '            </svg>\n' +
    '            <div>\n' +
    '                <strong>pe</strong><span>4</span>h\n' +
    '            </div>\n' +
    '    </a>\n' +
    '    </div>\n' +
    '</header>\n' +
    '\n' +
    '<!-- Form -->\n' +
    '<section class="content access signup">\n' +
    '    <div class="container-fluid gradient-blu">\n' +
    '        <h2 class="sliding">Create Your Account</h2>\n' +
    '        <!-- Log in -->\n' +
    '        <div class="box">\n' +
    '            <form method="post" class="sliding" name="signupForm">\n' +
    '                <div class="form-group">\n' +
    '                    <input type="text" id="Firstname" name="FirstName" required ng-model="firstName" ng-minlength="2" ng-maxlength="50" required="true">\n' +
    '                    <label for="Username">First Name</label>\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': signupForm.FirstName.$touched && signupForm.FirstName.$invalid }" ng-messages="signupForm.FirstName.$error"\n' +
    '                        ng-if="signupForm.FirstName.$touched">\n' +
    '                        <p ng-message="minlength">This field is too short.</p>\n' +
    '                        <p ng-message="maxlength">This field is too long.</p>\n' +
    '                        <p ng-message="required">This field is required</p>\n' +
    '                    </div>\n' +
    '                    <footer ng-class="{ \'has-error\': signupForm.FirstName.$touched && signupForm.FirstName.$invalid }"></footer>\n' +
    '                </div>\n' +
    '                <div class="form-group">\n' +
    '                    <input type="text" id="Lastname" name="Lastname" required ng-model="lastName" ng-minlength="2" ng-maxlength="50" required="true">\n' +
    '                    <label for="Lastname">Last Name</label>\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': signupForm.Lastname.$touched && signupForm.Lastname.$invalid }" ng-messages="signupForm.Lastname.$error"\n' +
    '                        ng-if="signupForm.Lastname.$touched">\n' +
    '                        <p ng-message="minlength">This field is too short.</p>\n' +
    '                        <p ng-message="maxlength">This field is too long.</p>\n' +
    '                        <p ng-message="required">This field is required</p>\n' +
    '                    </div>\n' +
    '                    <footer ng-class="{ \'has-error\': signupForm.Lastname.$touched && signupForm.Lastname.$invalid }"></footer>\n' +
    '                </div>\n' +
    '                <div class="form-group">\n' +
    '                    <input type="email" id="Email" name="Email" required ng-model="mail">\n' +
    '                    <label for="Email">Email</label>\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': signupForm.Email.$touched && signupForm.Email.$invalid }" ng-messages="signupForm.Email.$error"\n' +
    '                        ng-if="signupForm.Email.$touched">\n' +
    '                        <p ng-message="required">This field is required</p>\n' +
    '                        <p ng-message="email">This field is invalid</p>\n' +
    '                    </div>\n' +
    '                    <footer ng-class="{ \'has-error\': signupForm.Email.$touched && signupForm.Email.$invalid }"></footer>\n' +
    '                </div>\n' +
    '                <div class="form-group">\n' +
    '                    <button class="btn btn-primary btn-lg btn-block" ng-click="signup()" ng-disabled="!signupForm.$valid">Sign up</button>\n' +
    '                </div>\n' +
    '                <div class="text-right">\n' +
    '                    <p class="agreement">By clicking "Sign up",&nbsp; you agree to our\n' +
    '                        <a href="" ui-sref="legal" target="_blank">Privacy Policy</a>\n' +
    '                        <br class="hidden-xs"> and\n' +
    '                        <a href="" ui-sref="terms" target="_blank">Terms and Conditions</a>.</p>\n' +
    '                </div>\n' +
    '            </form>\n' +
    '        </div>\n' +
    '        <a href="" ui-sref="login">Log in</a>\n' +
    '    </div>\n' +
    '</section>');
}]);
